<template>
<span></span>
</template>

<script>
export default {
  name: 'DataChart',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    device: {
      type: String,
      required: true
    },
    endpoint: {
      type: String,
      required: true
    },
    reportInterval: {
      type: Number,
      default: 600000
    },
    unit: {
      type: String
    }
  },
  data() {
    return {
      timestamp: new Date(),
      rawData: null,
      rawDataType: 'pieReportHistory',
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        if (!val) this.unbind();
        this.$emit('input', val);
      }
    },
    itemKeys() {
      return Object.keys(this.rawData || {}).sort();
    },
    dataRef() {
      return this.$db.ref(`${this.rawDataType}/${this.device}/${this.endpoint}`);
    },
    dataCount() {
      return 100;
    },
    dataType: {
      get() {
        return this.rawDataType
      },
      set(val) {
        this.unbind();
        this.rawDataType = val;
        this.bind();
      }
    },
    missingInterval() {
      switch (this.rawDataType) {
        case 'pieReportQuarterHour':
          return 20 * 60 * 1000;
        default:
          return this.reportInterval * 3;
      }
    }
  },
  methods: {
    findMissing(data) {
      if (data) {
        let missing = [];
        Object.keys(data).map(t => parseInt(t)).reduce((prevT, currT) => {
          if (currT && prevT && currT - prevT > this.missingInterval) {
            missing.push((currT + prevT) / 2);
          }
          return currT;
        }, 0);
        missing.forEach(m => data[m] = null);
      }
      return data;
    },
    bind() {
      this.dataRef
        .orderByPriority()
        .startAt(new Date().getTime() / 1000 - 24 * 60 * 60)
        .limitToLast(this.dataCount)
        .on('value', snapshot => {
          this.rawData = this.findMissing(snapshot.val());
          this.timestamp = new Date();
        });
    },
    unbind() {
      this.dataRef.off();
    }
  },
  mounted() {
    this.bind();
  }
}
</script>
